export default [
    {
        name: 'United States',
        shortCode: 'US',
    },
    {
        name: 'Canada',
        shortCode: 'CA',
    },
    {
        name: 'Mexico',
        shortCode: 'MX',
    },
];
